import abTests from 'frontend/shared/javascripts/modules/ab_tests'
import { isNativeApp } from 'shared/javascripts/util/detection'
import { deviceDetector } from 'shared/javascripts/util/is_mobile'
import session from 'frontend/shared/javascripts/util/session'

function showAdvertisementModal(modalPath: string): void {
  session.nativeAppAdvertisementSeen = true
  void up.layer.open({
    url: modalPath,
    history: false,
    class: 'get-native-app-modal',
    size: 'auto',
    dismissible: ['key', 'button'],
    abort: 'all',
  })
}

function eligibleForAdvertisement(): boolean {
  // on app
  if (isNativeApp()) {
    // never show
    return false
  }

  // on tablet
  if (deviceDetector.isTablet()) {
    // don't show
    return false
  }

  // on desktop & mobile
  // show once to signed in users
  return !!session.signedIn && !session.nativeAppAdvertisementSeen
}

export default function showAppAdvertisement(modalPath: string): boolean | undefined {
  if (eligibleForAdvertisement()) {
    // Not in the variation of the A/B test user_home_hub. Counted as seen, so it doesn't turn up on a later page.
    if (abTests.variantCurrentlyActive('user_home_hub', 'b')) {
      session.nativeAppAdvertisementSeen = true
      return
    }

    showAdvertisementModal(modalPath)
    return true
  }
}
